import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import '../Styles/navigation.scss';
import '../Styles/darkMode.scss';
import { useAuth } from '../contexts/AuthContext'
import { useAuthModal } from './Auth/AuthModalManager';
import AccountDropdown from "./Auth/AccountDropdown";
import LicenseTimer from "./Auth/LicenseTimer";
import MiniLoader from "./ReusableComponents/MiniLoader";

const NavigationAuthSection = ({ onMenuClose, darkMode, toggleDarkMode }) => {

  const { user, loading, subscriptionActive, subscriptionLoading } = useAuth();
  const { openLogin, openSubscribe, openLicenseUpgrade } = useAuthModal();


  if (loading) {
    return <div className="auth-loading"></div>
  }

  const handleUpgradeClick = () => {
    openSubscribe();
    onMenuClose();
  };


  return (
    <div className="avatar-and-account-dropdown--container">

      <button
        onClick={toggleDarkMode}
        className="dark-mode-toggle"
        aria-label="Toggle dark mode"
      >
        {darkMode ? 
          <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z" />
          </svg>
          : 
          <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fillRule="evenodd" d="M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z" clipRule="evenodd" />
          </svg>
          }
          
      </button>

      <LicenseTimer />

      {subscriptionLoading && 
        <button
          className="auth-nav-btn"
        >
          <MiniLoader />
        </button>
      }

      {user ? (
        <>
          {!subscriptionLoading && subscriptionActive === false && (
            <button
              onClick={handleUpgradeClick}
              className="auth-nav-btn pri-btn upgrade-btn"
            >
              <span>Unlock Pro Features</span>
            </button>
          )}
          <AccountDropdown
            onMenuClose={onMenuClose}
            onOpenLicenseUpgrade={openLicenseUpgrade}
          />
        </>
      ) : (
        <button
          onClick={openLogin}
          className="sign-in-btn auth-nav-btn pri-btn"
        >
          <span>Log in/Sign up</span>
        </button>
      )}
    </div>
  )
}

const Navigation = ({ darkMode, toggleDarkMode }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Helper function to check if link is active
  const isActiveLink = (path) => {
    return location.pathname === path;
  };



  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={`nav-items--container ${menuOpen ? 'open' : ''}`}>


      {/* Navigation */}
      <div className={`nav-items--container ${menuOpen ? 'open' : ''}`}>
        <div className="hamburger-menu" onClick={toggleMenu}>
          {menuOpen ? (
            <svg width={30} height={30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg width={30} height={30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
          )}
        </div>

        <div className="nav-items items--left">
          {/* Logo Section */}
          <Link to="/generator" className="logo"
            onClick={(e) => {
              if (isActiveLink('/generator') || window.location.pathname.startsWith('/generator/')) {
                e.preventDefault(); // Prevent navigation
                return;
              }
              setMenuOpen(false);
            }}
          >

            <svg className="logo--default" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 568 146" fill="none">
              <path d="M65.28 108.44L20.39 37.9502V108.45H0V3.49023H23.24L64.97 70.9802V3.49023H85.52V108.45H65.29L65.28 108.44Z" fill="currentColor" />
              <path d="M92.1504 69.5601C92.1504 44.9001 107.48 28.6201 132.14 28.6201C156.8 28.6201 171.66 44.7401 171.66 69.5601C171.66 94.3801 156.33 110.5 132.14 110.5C107.95 110.5 92.1504 93.7501 92.1504 69.5601ZM150.95 69.5601C150.95 53.7501 144.63 46.0101 132.14 46.0101C119.65 46.0101 113.33 53.7601 113.33 69.5601C113.33 85.3601 119.65 93.2701 132.14 93.2701C144.63 93.2701 150.95 85.3701 150.95 69.5601Z" fill="currentColor" />
              <path d="M226.5 26.25C226.03 19.77 222.23 16.45 215.44 16.45C204.22 16.45 198.84 27.2 197.58 49.64C202.48 43.95 208.64 39.84 219.08 39.84C235.68 39.84 248.8 52.8 248.8 74.61C248.8 96.42 234.89 112.07 214.18 112.07C189.52 112.07 177.35 94.05 177.35 59.43C177.35 17.38 190.31 0 216.39 0C233.3 0 244.68 9.33 246.9 26.24H226.51L226.5 26.25ZM228.56 75.57C228.56 63.56 222.55 55.97 213.54 55.97C204.53 55.97 197.89 63.72 197.89 75.25C197.89 86.78 203.74 95.48 213.85 95.48C223.33 95.48 228.55 86.79 228.55 75.56L228.56 75.57Z" fill="currentColor" />
              <path d="M274.08 108.439V35.8895H252.58V21.6595C270.6 21.6595 276.61 15.6495 277.87 3.47949H294.62V108.439H274.07H274.08Z" fill="currentColor" />
              <path d="M302.379 108.44V87.0996H324.349V108.44H302.379Z" fill="currentColor" />
              <path d="M381.089 108.439C380.459 106.539 379.979 103.859 379.829 101.479C374.929 106.849 366.709 110.489 356.279 110.489C338.579 110.489 330.359 101.799 330.359 89.1494C330.359 66.6994 345.379 64.1794 366.079 61.3294C376.349 59.9094 379.199 57.8494 379.199 52.4794C379.199 47.4194 374.139 44.4194 366.079 44.4194C356.749 44.4194 352.959 48.9994 352.009 55.9594H332.879C333.199 39.8394 342.049 28.6094 367.019 28.6094C391.989 28.6094 400.209 39.6694 400.209 59.2794V108.439H381.079H381.089ZM379.669 70.3494C377.609 72.3994 373.979 73.5094 366.389 74.9294C354.689 77.1394 350.899 80.4594 350.899 87.0994C350.899 92.9494 354.379 95.7894 360.859 95.7894C371.449 95.7894 379.349 88.0394 379.509 78.8794L379.669 70.3394V70.3494Z" fill="currentColor" />
              <path d="M409.23 145.27V30.6801H428.99L429.15 40.1601C434.05 32.2601 441.32 28.6201 450.81 28.6201C470.41 28.6201 484.48 44.1101 484.48 70.3501C484.48 93.9001 472.63 110.5 452.55 110.5C442.91 110.5 435.32 106.55 429.47 98.3301V145.28H409.24L409.23 145.27ZM463.6 68.9301C463.6 55.0201 456.33 45.3801 446.05 45.3801C435.77 45.3801 428.66 54.5501 428.66 67.6701C428.66 84.5801 434.51 92.9601 445.89 92.9601C457.9 92.9601 463.59 84.9001 463.59 68.9301H463.6Z" fill="currentColor" />
              <path d="M491.9 145.27V30.6801H511.66L511.82 40.1601C516.72 32.2601 523.99 28.6201 533.48 28.6201C553.08 28.6201 567.15 44.1101 567.15 70.3501C567.15 93.9001 555.3 110.5 535.22 110.5C525.58 110.5 517.99 106.55 512.14 98.3301V145.28H491.91L491.9 145.27ZM546.27 68.9301C546.27 55.0201 539 45.3801 528.72 45.3801C518.44 45.3801 511.33 54.5501 511.33 67.6701C511.33 84.5801 517.18 92.9601 528.56 92.9601C540.57 92.9601 546.26 84.9001 546.26 68.9301H546.27Z" fill="currentColor" />
            </svg>


            {/* <svg className="logo--default" xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 568 189" fill="none">
              <path d="M65.28 151.44L20.39 80.9502V151.45H0V46.4902H23.24L64.97 113.98V46.4902H85.52V151.45H65.29L65.28 151.44Z" fill="currentColor" />
              <path d="M92.1504 112.56C92.1504 87.9001 107.48 71.6201 132.14 71.6201C156.8 71.6201 171.66 87.7401 171.66 112.56C171.66 137.38 156.33 153.5 132.14 153.5C107.95 153.5 92.1504 136.75 92.1504 112.56ZM150.95 112.56C150.95 96.7501 144.63 89.0101 132.14 89.0101C119.65 89.0101 113.33 96.7601 113.33 112.56C113.33 128.36 119.65 136.27 132.14 136.27C144.63 136.27 150.95 128.37 150.95 112.56Z" fill="currentColor" />
              <path d="M226.5 69.25C226.03 62.77 222.23 59.45 215.44 59.45C204.22 59.45 198.84 70.2 197.58 92.64C202.48 86.95 208.64 82.84 219.08 82.84C235.68 82.84 248.8 95.8 248.8 117.61C248.8 139.42 234.89 155.07 214.18 155.07C189.52 155.07 177.35 137.05 177.35 102.43C177.35 60.38 190.31 43 216.39 43C233.3 43 244.68 52.33 246.9 69.24H226.51L226.5 69.25ZM228.56 118.57C228.56 106.56 222.55 98.97 213.54 98.97C204.53 98.97 197.89 106.72 197.89 118.25C197.89 129.78 203.74 138.48 213.85 138.48C223.33 138.48 228.55 129.79 228.55 118.56L228.56 118.57Z" fill="currentColor" />
              <path d="M274.08 151.439V78.8895H252.58V64.6595C270.6 64.6595 276.61 58.6495 277.87 46.4795H294.62V151.439H274.07H274.08Z" fill="currentColor" />
              <path d="M302.379 151.44V130.1H324.349V151.44H302.379Z" fill="currentColor" />
              <path d="M381.089 151.439C380.459 149.539 379.979 146.859 379.829 144.479C374.929 149.849 366.709 153.489 356.279 153.489C338.579 153.489 330.359 144.799 330.359 132.149C330.359 109.699 345.379 107.179 366.079 104.329C376.349 102.909 379.199 100.849 379.199 95.4794C379.199 90.4194 374.139 87.4194 366.079 87.4194C356.749 87.4194 352.959 91.9994 352.009 98.9594H332.879C333.199 82.8394 342.049 71.6094 367.019 71.6094C391.989 71.6094 400.209 82.6694 400.209 102.279V151.439H381.079H381.089ZM379.669 113.349C377.609 115.399 373.979 116.509 366.389 117.929C354.689 120.139 350.899 123.459 350.899 130.099C350.899 135.949 354.379 138.789 360.859 138.789C371.449 138.789 379.349 131.039 379.509 121.879L379.669 113.339V113.349Z" fill="currentColor" />
              <path d="M409.23 188.27V73.6801H428.99L429.15 83.1601C434.05 75.2601 441.32 71.6201 450.81 71.6201C470.41 71.6201 484.48 87.1101 484.48 113.35C484.48 136.9 472.63 153.5 452.55 153.5C442.91 153.5 435.32 149.55 429.47 141.33V188.28H409.24L409.23 188.27ZM463.6 111.93C463.6 98.0201 456.33 88.3801 446.05 88.3801C435.77 88.3801 428.66 97.5501 428.66 110.67C428.66 127.58 434.51 135.96 445.89 135.96C457.9 135.96 463.59 127.9 463.59 111.93H463.6Z" fill="currentColor" />
              <path d="M491.9 188.27V73.6801H511.66L511.82 83.1601C516.72 75.2601 523.99 71.6201 533.48 71.6201C553.08 71.6201 567.15 87.1101 567.15 113.35C567.15 136.9 555.3 153.5 535.22 153.5C525.58 153.5 517.99 149.55 512.14 141.33V188.28H491.91L491.9 188.27ZM546.27 111.93C546.27 98.0201 539 88.3801 528.72 88.3801C518.44 88.3801 511.33 97.5501 511.33 110.67C511.33 127.58 517.18 135.96 528.56 135.96C540.57 135.96 546.26 127.9 546.26 111.93H546.27Z" fill="currentColor" />
              <rect x="396" width="171" height="60" rx="29" fill="#211F1C" />
              <path d="M424.746 47.0085V13.9521H441.025C447.498 13.9521 450.981 17.4386 450.981 22.9626C450.981 25.8003 449.239 28.1907 446.95 29.1355C449.737 30.1811 451.976 32.4204 451.976 37.1508C451.976 43.1756 447.945 47.0085 439.63 47.0085H424.746ZM431.417 19.6778V26.8459H440.128C442.865 26.8459 444.31 25.6019 444.31 23.2618C444.31 20.7234 442.966 19.6778 439.731 19.6778H431.417ZM440.178 41.3805C443.365 41.3805 445.255 39.3396 445.255 36.65C445.255 33.762 443.362 32.4676 440.276 32.4676H431.413V41.3773H440.175L440.178 41.3805Z" fill="#FBFAF8" />
              <path d="M456.156 47.0085V13.9521H480.451V19.7282H462.877V26.7986H479.056V32.6219H462.877V41.1348H481.248V47.0085H456.156Z" fill="#FBFAF8" />
              <path d="M494.168 47.0085V19.7282H484.213V13.9521H511.096V19.7282H501.091V47.0085H494.171H494.168Z" fill="#FBFAF8" />
              <path d="M531.481 47.0085L529.39 40.1868H517.192L514.852 47.0085H507.533L519.334 13.9521H527.349L538.999 47.0085H531.481ZM523.268 21.369H523.217L518.985 34.5116H527.397L523.265 21.369H523.268Z" fill="#FBFAF8" />
            </svg> */}


            <svg className="logo--mobile" xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 295 113" fill="none">
              <path d="M65.28 108.44L20.39 37.9502V108.45H0V3.49023H23.24L64.97 70.9802V3.49023H85.52V108.45H65.29L65.28 108.44Z" fill="currentColor" />
              <path d="M92.1504 69.5601C92.1504 44.9001 107.48 28.6201 132.14 28.6201C156.8 28.6201 171.66 44.7401 171.66 69.5601C171.66 94.3801 156.33 110.5 132.14 110.5C107.95 110.5 92.1504 93.7501 92.1504 69.5601ZM150.95 69.5601C150.95 53.7501 144.63 46.0101 132.14 46.0101C119.65 46.0101 113.33 53.7601 113.33 69.5601C113.33 85.3601 119.65 93.2701 132.14 93.2701C144.63 93.2701 150.95 85.3701 150.95 69.5601Z" fill="currentColor" />
              <path d="M226.5 26.25C226.03 19.77 222.23 16.45 215.44 16.45C204.22 16.45 198.84 27.2 197.58 49.64C202.48 43.95 208.64 39.84 219.08 39.84C235.68 39.84 248.8 52.8 248.8 74.61C248.8 96.42 234.89 112.07 214.18 112.07C189.52 112.07 177.35 94.05 177.35 59.43C177.35 17.38 190.31 0 216.39 0C233.3 0 244.68 9.33 246.9 26.24H226.51L226.5 26.25ZM228.56 75.57C228.56 63.56 222.55 55.97 213.54 55.97C204.53 55.97 197.89 63.72 197.89 75.25C197.89 86.78 203.74 95.48 213.85 95.48C223.33 95.48 228.55 86.79 228.55 75.56L228.56 75.57Z" fill="currentColor" />
              <path d="M274.08 108.439V35.8895H252.58V21.6595C270.6 21.6595 276.61 15.6495 277.87 3.47949H294.62V108.439H274.07H274.08Z" fill="currentColor" />
            </svg>

            {/* <svg style={{ marginTop: '-6px' }} className="logo--mobile" xmlns="http://www.w3.org/2000/svg" width="44" viewBox="0 0 295 184" fill="none">
              <path d="M65.28 179.44L20.39 108.95V179.45H0V74.4902H23.24L64.97 141.98V74.4902H85.52V179.45H65.29L65.28 179.44Z" fill="currentColor" />
              <path d="M92.1504 140.56C92.1504 115.9 107.48 99.6201 132.14 99.6201C156.8 99.6201 171.66 115.74 171.66 140.56C171.66 165.38 156.33 181.5 132.14 181.5C107.95 181.5 92.1504 164.75 92.1504 140.56ZM150.95 140.56C150.95 124.75 144.63 117.01 132.14 117.01C119.65 117.01 113.33 124.76 113.33 140.56C113.33 156.36 119.65 164.27 132.14 164.27C144.63 164.27 150.95 156.37 150.95 140.56Z" fill="currentColor" />
              <path d="M226.5 97.25C226.03 90.77 222.23 87.45 215.44 87.45C204.22 87.45 198.84 98.2 197.58 120.64C202.48 114.95 208.64 110.84 219.08 110.84C235.68 110.84 248.8 123.8 248.8 145.61C248.8 167.42 234.89 183.07 214.18 183.07C189.52 183.07 177.35 165.05 177.35 130.43C177.35 88.38 190.31 71 216.39 71C233.3 71 244.68 80.33 246.9 97.24H226.51L226.5 97.25ZM228.56 146.57C228.56 134.56 222.55 126.97 213.54 126.97C204.53 126.97 197.89 134.72 197.89 146.25C197.89 157.78 203.74 166.48 213.85 166.48C223.33 166.48 228.55 157.79 228.55 146.56L228.56 146.57Z" fill="currentColor" />
              <path d="M274.08 179.439V106.889H252.58V92.6595C270.6 92.6595 276.61 86.6495 277.87 74.4795H294.62V179.439H274.07H274.08Z" fill="currentColor" />
              <rect x="124" width="171" height="60" rx="29" fill="#211F1C" />
              <path d="M150.746 47.5867V13.373H167.595C174.294 13.373 177.899 16.9815 177.899 22.699C177.899 25.636 176.097 28.1101 173.727 29.088C176.612 30.1702 178.929 32.4878 178.929 37.3839C178.929 43.6196 174.757 47.5867 166.151 47.5867H150.746ZM157.65 19.2992V26.7182H166.666C169.499 26.7182 170.995 25.4306 170.995 23.0087C170.995 20.3814 169.603 19.2992 166.256 19.2992H157.65ZM166.719 41.7616C170.017 41.7616 171.973 39.6494 171.973 36.8656C171.973 33.8765 170.014 32.5367 166.82 32.5367H157.647V41.7584H166.715L166.719 41.7616Z" fill="#FBFAF8" />
              <path d="M183.256 47.5867V13.373H208.401V19.3513H190.212V26.6693H206.957V32.6964H190.212V41.5074H209.226V47.5867H183.256Z" fill="#FBFAF8" />
              <path d="M222.599 47.5867V19.3513H212.295V13.373H240.12V19.3513H229.764V47.5867H222.602H222.599Z" fill="#FBFAF8" />
              <path d="M261.218 47.5867L259.054 40.5262H246.429L244.007 47.5867H236.432L248.646 13.373H256.942L268.999 47.5867H261.218ZM252.717 21.0496H252.665L248.284 34.6523H256.99L252.714 21.0496H252.717Z" fill="#FBFAF8" />
            </svg> */}
          </Link>
          <Link
            className={`svg---text item--left ${(isActiveLink('/generator') || window.location.pathname.startsWith('/generator/')) ? 'active' : ''}`}
            to="/generator"
            onClick={(e) => {
              if (isActiveLink('/generator') || window.location.pathname.startsWith('/generator/')) {
                e.preventDefault();
                return;
              }
              setMenuOpen(false);
            }}
          >
            <span>Generator</span>
          </Link>
          <Link className={`svg---text item--left ${isActiveLink('/saved') ? 'active' : ''}`} to="/saved"
            onClick={(e) => {
              if (isActiveLink('/saved')) {
                e.preventDefault();
                return;
              }
              setMenuOpen(false);
            }}
          >
            <span>Saved</span>
          </Link>
          <Link className={`svg---text item--left ${isActiveLink('/themes') ? 'active' : ''}`} to="/themes"
            onClick={(e) => {
              if (isActiveLink('/themes')) {
                e.preventDefault();
                return;
              }
              setMenuOpen(false);
            }}
          >
            <span>Inspiration</span>
          </Link>

          <a
            className={`svg---text item--left`}
            href="https://www.figma.com/community/plugin/1544422242387734389"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
          >
            <span>Figma Plugin</span>
          </a>
        </div>

        <div className="nav-items items--right">
          {/* feedback */}
          <button className="item--right svg---text">
            <span><a target="_blank" href="https://forms.gle/Y58FMYsxAy99oAsp9" rel="noreferrer">Feedback</a></span>
          </button>

          {/* bug report */}
          <button className="item--right svg---text">
            <span><a href="https://forms.gle/GY2ugb8ygEmAJ3KcA" target="_blank" rel="noreferrer">Report a bug</a></span>
          </button>

          <NavigationAuthSection
            onMenuClose={handleMenuClose}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
          />

        </div>
      </div>
      {/* Overlay that appears when menu is open */}
      <div className={`overlay ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}></div>
    </nav>
  );
};

export default Navigation;




























